// extracted by mini-css-extract-plugin
export var subtitle = "_8r-2";
export var title = "_8r-0";
export var titleNoWrap = "_8r-1";